import { combineReducers } from 'redux'
import data from './property'

export default combineReducers({ data })
